"use strict";
APP.ui.ScoreUI = function ( p_type, p_value ) {

    // Invoke (needed)
    EHDI.aka.Container.call( this );

    // Properties

    // ** Parent (This reference)
    var _parent = this;

    // ** General Values
    var _type, _isPaused, _isUpdateActive, _value;

    // ** Graphics
    var _sprBG, _sprFlash, _sprLine, _sprSparkle, _txtHeader, _txtValue, _timelineUpdate;

    // ** General Methods

    var _setValue = function ( p_value, p_addValue ) {
        
        // Check if param values are invalid, then throw error
        if ( typeof p_value !== "number" ) throw "Score value for score ui is not valid. Must be number.";
        if ( p_value < 0 ) throw "Score value for score ui is not valid. Must be greater than or equal to zero.";

        // Check if some propeties are invalid, then return
        if ( !_txtValue ) return;
        if ( !_timelineUpdate ) return;

        // Set value
        if ( p_addValue === true ) _value += p_value;
        else _value = p_value;

        // Set text
        var str = _value.toString();
        if ( _txtValue.text !== str ) _txtValue.text = str; 
        
        // Start animation
        _isUpdateActive = true;
        _timelineUpdate.restart();
        _timelineUpdate.play();

        // Play sfx
        APP.managers.sound.playSFX( "score_points", 0.60 ); 

    };

    var _toggleEffects = function( p_value ) {
        
        // Check if param values are invalid, then throw error
        if ( p_value !== true &&
            p_value !== false ) throw "Value must be boolean.";
        
        // Toggle
        if ( _sprLine ) _sprLine.visible = p_value;
        if ( _sprSparkle ) _sprSparkle.visible = p_value;
    }
    
    var _toggleFlash  = function( p_value ) {

        // Check if param values are invalid, then throw error
        if ( p_value !== true &&
            p_value !== false ) throw "Value must be boolean.";
        
        // Toggle
        if ( _sprFlash ) _sprFlash.visible = p_value;
    }

    // ** Initialization Methods

    var _initProps = function ( p_type, p_value ) {

        // Check if param values are invalid, then throw error
        if ( p_type !== APP.ui.ScoreType.HIGHSCORE &&
            p_type !== APP.ui.ScoreType.SCORE ) throw "Type value for score ui is invalid.";

        if ( typeof p_value !== "number" ) throw "Score value for score ui is not valid. Must be number.";
        if ( p_value < 0 ) throw "Score value for score ui is not valid. Must be greater than or equal to zero.";

        // Initialize properties
        _type = p_type;
        _isPaused = false;
        _isUpdateActive = false;
        _value = p_value;
    };

    var _initGraphics = function () {

        // Initialize graphics
        if ( !_sprBG ) {

            _sprBG = new EHDI.aka.Sprite( EHDI.Assets.images[ "assets/ui/gfx_container.png" ] );

            if ( _parent ) _parent.addChild( _sprBG );
        }
        
        if ( !_txtHeader ) {

            var strHeader;

            if ( _type === APP.ui.ScoreType.HIGHSCORE ) strHeader = APP.managers.json.getLocale("STR_CONT_BEST");
            else if ( _type === APP.ui.ScoreType.SCORE ) strHeader = APP.managers.json.getLocale("STR_CONT_SCORETITLE");

            _txtHeader = new EHDI.displays.TextSprite(strHeader);
            _txtHeader.anchor.set( 0.5, 0.5 );
            _txtHeader.position.set( _sprBG.width * 0.169, _sprBG.height * 0.4 );

            if ( _parent ) _parent.addChild( _txtHeader );
        }

        if ( !_txtValue ) {
            
            _txtValue = new EHDI.displays.TextSprite(APP.managers.json.getLocale("STR_CONT_BESTSCORE"));
            _txtValue.text =  _value.toString();            
            _txtValue.anchor.set( 0.5, 0.5 );
            _txtValue.position.set( _sprBG.width * 0.675, _sprBG.height * 0.45 );
            
            if ( _parent ) _parent.addChild( _txtValue );
        }

        if ( !_sprFlash ) {

            _sprFlash = new EHDI.aka.Sprite( EHDI.Assets.images[ "assets/ui/gfx_container_white.png" ] );
            _sprFlash.alpha = 0;
            _sprFlash.visible = false;

            if ( _parent ) _parent.addChild( _sprFlash );
        }

        if ( !_sprSparkle ) {

            _sprSparkle = new EHDI.aka.Sprite( EHDI.Assets.images[ "assets/ui/gfx_flare_star.png" ] );
            _sprSparkle.anchor.set( 0.5, 0.5 );
            _sprSparkle.position.set( _txtHeader.x, _txtHeader.y );
            _sprSparkle.scale.set( 0, 0 );
            _sprSparkle.visible = false;
            if ( _parent ) _parent.addChild( _sprSparkle );
        }

        if ( !_sprLine ) {

            _sprLine = new EHDI.aka.Sprite( EHDI.Assets.images[ "assets/ui/gfx_flare_long.png" ] );
            _sprLine.anchor.set( 0.5, 0.5 );
            _sprLine.position.set( _sprBG.width * 0.5, _sprBG.height * 0.4 );
            _sprLine.scale.set( 0, 1 );
            _sprLine.visible = false;
            if ( _parent ) _parent.addChild( _sprLine );
        }

        if ( !_timelineUpdate ) {

            _timelineUpdate = new TimelineMax( { onComplete: function () { if ( _isUpdateActive === true ) _isUpdateActive = false; } } );
            _timelineUpdate.to( _txtValue.scale, 0.1, { x: 1.5, y : 1.5 } );
            _timelineUpdate.to( _txtValue.scale, 0.1, { x: 1, y : 1 } );
            _timelineUpdate.addCallback( _toggleEffects, "+=0", [ true ] );
            _timelineUpdate.addCallback( _toggleFlash, "+=0", [ true ] );
            _timelineUpdate.to( _sprSparkle.scale, 0.1, { x: 1, y : 1, ease: Power0.easeNone } );
            _timelineUpdate.to( _sprLine.scale, 0.2, { x: 1, y : 1, ease: Power0.easeNone }, "-=0.1" );
            _timelineUpdate.to( _sprFlash, 0.05, { alpha : 0.75 } );
            _timelineUpdate.to( _sprSparkle, 0.15, { x: _parent.width * 0.9, rotation: 5, ease: Power0.easeNone }, "-=0.15" );
            _timelineUpdate.to( _sprFlash, 0.1, { alpha : 0 }, "-=0.025" );
            _timelineUpdate.addCallback( _toggleFlash, "-=0.05", [ false ] );
            _timelineUpdate.addCallback( _toggleEffects, "+=0.025", [ false ] );
            _timelineUpdate.pause();
        }
    };

    var _initListeners = function () {};

    // ** Kill Methods
    var _killProps = function () {

        _parent = null;
        _type = null;
        _isPaused = null;
        _isUpdateActive = null;
        _value = null;
    };

    var _killGraphics = function () {

        if ( _sprBG ) {
            
            if ( _sprBG.parent ) _sprBG.parent.removeChild( _sprBG );

            _sprBG.destroy( { children: true } );
        }
        _sprBG = null;

        if ( _sprFlash ) {
            
            if ( _sprFlash.parent ) _sprFlash.parent.removeChild( _sprFlash );

            _sprFlash.destroy( { children: true } );
        }
        _sprFlash = null;

        if ( _sprLine ) {
            
            if ( _sprLine.parent ) _sprLine.parent.removeChild( _sprLine );

            _sprLine.destroy( { children: true } );
        }
        _sprLine = null;

        if ( _sprSparkle ) {
            
            if ( _sprSparkle.parent ) _sprSparkle.parent.removeChild( _sprSparkle );

            _sprSparkle.destroy( { children: true } );
        }
        _sprSparkle = null;

        if ( _txtHeader ) {
            
            if ( _txtHeader.parent ) _txtHeader.parent.removeChild( _txtHeader );

            _txtHeader.destroy( { children: true } );
        }
        _txtHeader = null;

        if ( _txtValue ) {
            
            if ( _txtValue.parent ) _txtValue.parent.removeChild( _txtValue );

            _txtValue.destroy( { children: true } );
        }
        _txtValue = null;

        if ( _timelineUpdate ) {

            _timelineUpdate.stop();
            _timelineUpdate.kill();
        }
        _timelineUpdate = null;
    };

    var _killListeners = function () { };

    // Public Methods

    this.destroy = function () {
        
        // Kill listeners
        _killListeners();

        // Kill graphics
        _killGraphics();

        // Kill props
        _killProps();

        // Call superclass method
        APP.ui.ScoreUI.prototype.destroy.apply( this, arguments );
    };

    // Call init methods
    _initProps( p_type, p_value );
    _initGraphics();
    _initListeners();

    Object.defineProperties( _parent, {
        "value": {
            get: function () { return _value; },
            enumerable: true
        },
        "paused": {
            get: function () { return _isPaused; },
            set: function ( p_value ) {

                if ( p_value !== true &&
                    p_value !== false ) throw "Pause value should be boolean.";

                if ( _isPaused === p_value ) return;

                // Set isPaused
                _isPaused = p_value;
                
                if ( _isPaused === true ) {

                    if ( _timelineUpdate ) {

                        if ( _timelineUpdate.isActive() && _isUpdateActive === true ) _timelineUpdate.pause();
                    }

                }
                else if ( _isPaused === false ) {

                    if ( _timelineUpdate ) {

                        if ( !_timelineUpdate.isActive() && _isUpdateActive === true ) _timelineUpdate.play();
                    }
                }
                
            },
            enumerable: true
        },
        "setScore": {
            enumerable: true,
            writable: true,
            value: function ( p_value, p_addValue ) { _setValue( p_value, p_addValue ); } 
        }
    });

    // Return
    return _parent;
};
APP.ui.ScoreUI.prototype = Object.create( EHDI.aka.Container.prototype );
APP.ui.ScoreUI.prototype.constructor = APP.ui.ScoreUI;